$(function(){
    if (typeof window.adblock_skipped == 'undefined' || !window.adblock_skipped) {
        $('[data-adblock-warning]').html(__('adblock.warning')).show();
    }
});